(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('quick-view-dialog');
  if (!dialog) return;
  const content = dialog.querySelector('[data-quick-view-content]');
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character]));
  const render = (product) => {
    const variants = product.variants.filter((variant) => variant.available);
    const options = variants.map((variant) => '<option value="' + variant.id + '">' + escapeHtml(variant.title) + ' — ' + money(variant.price) + '</option>').join('');
    const image = product.featured_image || (product.images && product.images[0]) || '';
    content.innerHTML = '<div class="quick-view-product"><img class="quick-view-product__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="720" height="720"><div><h2 class="quick-view-product__title" id="quick-view-title">' + escapeHtml(product.title) + '</h2><p class="quick-view-product__price">' + money(product.price) + '</p><form class="quick-view-product__actions" data-quick-view-form><select name="id" aria-label="Variant">' + options + '</select><input type="hidden" name="quantity" value="1"><button class="btn btn--primary btn--full" type="submit"' + (variants.length ? '' : ' disabled') + '>' + (variants.length ? dialog.dataset.addLabel : dialog.dataset.soldLabel) + '</button><a class="btn btn--secondary btn--full" href="' + escapeHtml(product.url) + '">' + dialog.dataset.detailsLabel + '</a></form></div></div>';
  };
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-quick-view]');
    if (!trigger) return;
    event.preventDefault();
    content.innerHTML = '<p>' + dialog.dataset.loadingLabel + '</p>';
    dialog.showModal();
    try {
      const response = await fetch('/products/' + encodeURIComponent(trigger.dataset.productHandle) + '.js');
      if (!response.ok) throw new Error('Product request failed');
      render(await response.json());
    } catch (error) {
      content.innerHTML = '<p>' + dialog.dataset.errorLabel + '</p>';
    }
  });
  dialog.querySelector('[data-quick-view-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-quick-view-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:Number(form.elements.id.value),quantity:1}) });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await fetch('/cart.js').then((result) => result.json());
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      dialog.close();
      const cartToggle = document.querySelector('[data-cart-toggle]');
      if (cartToggle) cartToggle.click();
    } catch (error) {
      button.disabled = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
function initCollectionFilters() {
  const root = document.getElementById('main-collection');
  if (!root || root.dataset.filtersReady) return;
  root.dataset.filtersReady = 'true';
  const form = root.querySelector('[data-filter-form]');
  const dialog = root.querySelector('dialog');
  const trigger = root.querySelector('[data-toggle-filters]');
  const close = root.querySelector('.collection-filters__close');
  const sort = root.querySelector('[data-sort-by]');
  let previousOverflow = '';
  if (trigger && dialog) {
    trigger.addEventListener('click', () => {
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      trigger.focus();
    });
  }
  if (form) {
    form.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(window.location.href);
      url.pathname = new URL(form.action).pathname;
      for (const key of Array.from(url.searchParams.keys())) {
        if (key.startsWith('filter.') || key === 'page' || key === 'sort_by') url.searchParams.delete(key);
      }
      for (const [key, value] of new FormData(form)) {
        if (String(value).trim() !== '') url.searchParams.append(key, value);
      }
      url.hash = 'main-collection';
      window.location.assign(url.toString());
    });
    if (sort) sort.addEventListener('change', () => form.requestSubmit());
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollectionFilters);
else initCollectionFilters();
document.addEventListener('shopify:section:load', initCollectionFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(() => {
  const storageKey = 'mirha-recently-viewed';
  const current = document.querySelector('[data-current-product-handle]')?.dataset.currentProductHandle;
  let handles = [];
  try { handles = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (error) { handles = []; }
  if (current) {
    handles = [current, ...handles.filter((handle) => handle !== current)].slice(0, 12);
    localStorage.setItem(storageKey, JSON.stringify(handles));
  }
  document.querySelectorAll('[data-recently-viewed]').forEach(async (section) => {
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const limit = Number(section.dataset.limit || 4);
    const visibleHandles = handles.filter((handle) => handle !== current).slice(0, limit);
    if (!visibleHandles.length) { section.hidden = true; return; }
    const products = await Promise.all(visibleHandles.map(async (handle) => {
      try {
        const response = await fetch('/products/' + encodeURIComponent(handle) + '.js');
        return response.ok ? response.json() : null;
      } catch (error) { return null; }
    }));
    const locale = document.documentElement.lang || 'de-DE';
    const format = (cents) => new Intl.NumberFormat(locale, { style:'currency', currency:'EUR' }).format(cents / 100);
    const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (character) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[character]));
    grid.innerHTML = products.filter(Boolean).map((product) => {
      const image = product.featured_image || (product.images && product.images[0]) || '';
      return '<a class="recently-viewed__card" href="' + escapeHtml(product.url) + '"><img class="recently-viewed__image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="520" height="520"><h3 class="recently-viewed__title">' + escapeHtml(product.title) + '</h3><span class="recently-viewed__price">' + format(product.price) + '</span></a>';
    }).join('');
    section.hidden = !grid.children.length;
  });
})();

  } catch(e) { console.error(e); }
})();
})();
